import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import { mapState } from 'vuex';
export default {
  name: 'NestedDashboardOptionsEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    ...mapState('dashboards', ['dashboards']),
    nestedDashboardId: {
      get() {
        return this.getByKey('dashboardId');
      },
      set(val) {
        if (!val) {
          this.setByKey(null, undefined);
          return;
        }
        this.setByKey('dashboardId', val);
      }
    },
    nestedDashboardDefinition() {
      const def = this.dashboards.find(dashboard => dashboard.id === this.nestedDashboardId);
      return def ? def.value : {};
    },
    eventParametersAsSelectItems() {
      const customParametersAsSelectItems = Object.keys(this.customParameters).map(key => `{{dashboard.parameter.${key}}}`);
      return ['{{event.dtwin.id}}', '{{event.dtwin.title}}', ...customParametersAsSelectItems];
    },
    navigationType: {
      get() {
        return this.getByKey('navigationType');
      },
      set(val) {
        this.setByKey('navigationType', val);
      }
    },
    navigationTypeItems() {
      const options = ['navigate', 'replace'];
      return options.map(option => ({
        text: this.$t(`Dashboards.nestedDashboard.navigationType.${option}`),
        value: option
      }));
    }
  },
  methods: {
    getByKey(key, defaultValue) {
      return get(this.value, key, defaultValue);
    },
    setByKey(key, val) {
      if (key === null) {
        this.$emit('input', null);
        return;
      }
      const clone = cloneDeep(this.value || {});
      if (key.startsWith('parameters.') && val === null) {
        val = undefined;
      }
      set(clone, key, val);
      if (key === 'dashboardId' && !clone.navigationType) {
        set(clone, 'navigationType', 'navigate');
      }
      this.$emit('input', clone);
    }
  }
};